import { DeviceHistory } from "./DeviceHistory";

export enum DeviceStatus {
	ONLINE = "online",
	ERROR = "error",
	OFFLINE = "offline",
	ALL = "all",
}

export interface DeviceStatusWithDisplayDto {
	status: DeviceStatus;
	displayName: string;
}

export default interface UpdateDeviceDto {
	_id: string;

	id: string;
	deviceId: string; //RPU

	deviceType: string; //Model

	address: string;

	connectionType: string;

	socketId: string;

	permissionaryId: string;

	city: string;

	state: string;

	ipAddress: string;

	port: number;

	lastLoadedProfileDate: string;

	lastLoadedProfileDateUtc: string;

	customerId: string;

	isBackUp: boolean;

	timeZone: string; //(UTC-06:00) Guadalajara, Mexico City, Monterrey

	accountNumber: string;

	commAddress: number;

	status: DeviceStatus;

	notes: string; //any notes about the device

	processing: boolean;

	createdAt: string;

	updatedAt: string;

	lastNotifiedAt?: string;

	exceptions: DeviceError[];
}

export enum DeviceError {
	// DEVICE_OFFLINE = "DEVICE_OFFLINE",
	// NEWEST_DEVICE_CONNECTIVITY_REPORT_OFFLINE = "NEWEST_DEVICE_CONNECTIVITY_REPORT_OFFLINE",
	// LAST_LOADED_DATE_PASSED = "LAST_LOADED_DATE_PASSED",
	// NO_CONNECTIVITY_REPORT = "NO_CONNECTIVITY_REPORT",
	// NO_DEVICE_HISTORY = "NO_DEVICE_HISTORY",
	// DEVICE_LAST_LOADED_PROFILE_TOO_FAR = "DEVICE_LAST_LOADED_PROFILE_TOO_FAR",
	// DEVICE_HISTORY_NOT_COMMUNICATING = "DEVICE_HISTORY_NOT_COMMUNICATING",
	// DEVICE_HISTORY_NOT_ONLINE = "DEVICE_HISTORY_NOT_ONLINE",
	// DEVICE_HISTORY_VOLTAGE_TOO_LOW = "DEVICE_HISTORY_VOLTAGE_TOO_LOW",
	// DEVICE_HISTORY_CABINET_OPEN = "DEVICE_HISTORY_CABINET_OPEN",
	// DEVICE_HISTORY_MAIN_VOLTAGE_OFF = "DEVICE_HISTORY_MAIN_VOLTAGE_OFF",

	// CONNECTIVITY_REPORT_NOT_REPORTING = "CONNECTIVITY_REPORT_NOT_REPORTING",
	// CONNECTIVITY_REPORT_NOT_ONLINE = "CONNECTIVITY_REPORT_NOT_ONLINE",

	NO_DEVICE_HISTORY = "NO_DEVICE_HISTORY",
	DEVICE_HISTORY_ERROR = "DEVICE_HISTORY_ERROR",
	DEVICE_HISTORY_OFFLINE = "DEVICE_HISTORY_OFFLINE",
	DEVICE_HISTORY_CABINET_OPEN = "DEVICE_HISTORY_CABINET_OPEN",
}

export const DeviceErrorMessage: Record<string, string> = {
	// DEVICE_OFFLINE:
	// 	"Medidor incomunicado (Se realizo pruebas de conectividad y fallo)",
	// NEWEST_DEVICE_CONNECTIVITY_REPORT_OFFLINE:
	// 	"Reporte de conectividad más reciente fallido",
	// LAST_LOADED_DATE_PASSED: "Perfil de carga incomunicado por más de 24 horas",
	// NO_CONNECTIVITY_REPORT: "Reporte de conectividad no disponible",

	// DEVICE_LAST_LOADED_PROFILE_TOO_FAR:
	// 	"Perfil de carga incomunicado por más de 24 horas",
	// DEVICE_HISTORY_VOLTAGE_TOO_LOW: "Voltaje de punto de carga muy bajo",

	// DEVICE_HISTORY_MAIN_VOLTAGE_OFF: "Voltaje principal fuera de servicio",

	// CONNECTIVITY_REPORT_NOT_REPORTING: "Reporte de conectividad incomunicado",
	// CONNECTIVITY_REPORT_NOT_ONLINE: "Reporte de conectividad fuera de linea",
	NO_DEVICE_HISTORY: "No hay historial de medidor",
	DEVICE_HISTORY_ERROR: "Historial de medidor incomunicado (Prueba fallida)",
	DEVICE_HISTORY_OFFLINE:
		"Historial de medidor fuera de linea (limite de tiempo para reporte pasado)",
	DEVICE_HISTORY_CABINET_OPEN: "Gabinete de medidor abierto",
};

export interface CreateDeviceDto {
	deviceId: string; //RPU

	deviceType: string; //Model

	address: string;

	connectionType: string;

	socketId: string;

	permissionaryId: string;

	city: string;

	state: string;

	ipAddress: string;

	port: number;

	lastLoadedProfileDate: string;

	lastLoadedProfileDateUtc: string;

	customerId: string;

	isBackUp: boolean;

	timeZone: string; //(UTC-06:00) Guadalajara, Mexico City, Monterrey

	accountNumber: string;

	commAddress: number;

	status: DeviceStatus;

	notes: string; //any notes about the device

	processing?: boolean;

	createdAt?: string;

	updatedAt?: string;

	lastNotifiedAt?: string;

	exceptions?: DeviceError[];
}

export interface Device {
	_id: string;

	id: string;

	deviceId: string; //RPU

	deviceType: string; //Model

	address: string;

	connectionType: string;

	socketId: string;

	permissionaryId: string;

	city: string;

	state: string;

	ipAddress: string;

	port: number;

	lastLoadedProfileDate: string;

	lastLoadedProfileDateUtc: string;

	customerId: string;

	isBackUp: boolean;

	timeZone: string; //(UTC-06:00) Guadalajara, Mexico City, Monterrey

	accountNumber: string;

	commAddress: number;

	status: DeviceStatus;

	notes: string; //any notes about the device

	processing: boolean;

	createdAt: string;

	updatedAt: string;

	lastNotifiedAt?: string;

	exceptions: DeviceError[];
}

export interface FetchDeviceWithHistoryDto extends Device {
	history: DeviceHistory[];
}
